import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface FundState {
  selectedFundId: string | null;
  selectedBenchmarkId: string | null;
  dateRange: {
    startDate: string | null;
    endDate: string | null;
  };
}

const initialState: FundState = {
  selectedFundId: localStorage.getItem('selectedFundId'),
  selectedBenchmarkId: localStorage.getItem('selectedBenchmarkId'),
  dateRange: {
    startDate: null,
    endDate: null,
  },
};

const fundSlice = createSlice({
  name: 'fund',
  initialState,
  reducers: {
    setSelectedFund: (state, action: PayloadAction<string | null>) => {
      state.selectedFundId = action.payload;
      if (action.payload) {
        localStorage.setItem('selectedFundId', action.payload);
      } else {
        localStorage.removeItem('selectedFundId');
      }
    },
    setSelectedBenchmark: (state, action: PayloadAction<string | null>) => {
      state.selectedBenchmarkId = action.payload;
      if (action.payload) {
        localStorage.setItem('selectedBenchmarkId', action.payload);
      } else {
        localStorage.removeItem('selectedBenchmarkId');
      }
    },
    setDateRange: (state, action: PayloadAction<{ startDate: string | null; endDate: string | null }>) => {
      state.dateRange = action.payload;
    },
    clearFundSelection: (state) => {
      state.selectedFundId = null;
      state.selectedBenchmarkId = null;
      state.dateRange = { startDate: null, endDate: null };
      localStorage.removeItem('selectedFundId');
      localStorage.removeItem('selectedBenchmarkId');
    },
  },
});

export const { setSelectedFund, setSelectedBenchmark, setDateRange, clearFundSelection } = fundSlice.actions;

// Selectors
export const selectSelectedFundId = (state: { fund: FundState }) => state.fund.selectedFundId;
export const selectSelectedBenchmarkId = (state: { fund: FundState }) => state.fund.selectedBenchmarkId;
export const selectDateRange = (state: { fund: FundState }) => state.fund.dateRange;

export default fundSlice.reducer;
